export default {
  importCSV: 'Import CSV',
};
